// Note: this is meant to run in the browser
export const getFileHashSHA256 = async (
  file: File | ArrayBuffer
): Promise<string> => {
  const arrayBuffer = file instanceof File ? await file.arrayBuffer() : file
  const hash = await crypto.subtle.digest('SHA-256', arrayBuffer)
  const hashArray = Array.from(new Uint8Array(hash))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}
